import { render, staticRenderFns } from "./RackGroupItem.vue?vue&type=template&id=f71fdd16&scoped=true&"
import script from "./RackGroupItem.vue?vue&type=script&lang=js&"
export * from "./RackGroupItem.vue?vue&type=script&lang=js&"
import style0 from "./RackGroupItem.vue?vue&type=style&index=0&id=f71fdd16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71fdd16",
  null
  
)

export default component.exports